import { COMPANY_SIZES, COUNTRY_CODES, inputClass, labelClass } from "./constants";

const onlyDigits = (value) => value.replace(/[^0-9 ]/g, "");

export const TextField = ({
    label,
    testId,
    value,
    onChange,
    placeholder,
    type = "text",
}) => (
    <div>
        <label className={labelClass}>{label}</label>
        <input
            data-testid={testId}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={inputClass}
        />
    </div>
);

export const CompanySizeField = ({ value, onChange }) => (
    <div>
        <label className={labelClass}>Company Size</label>
        <select
            data-testid="company-size-select"
            value={value}
            onChange={onChange}
            className={`${inputClass} appearance-none cursor-pointer`}
        >
            <option value="" disabled>
                Select company size…
            </option>
            {COMPANY_SIZES.map((c) => (
                <option key={c} value={c} className="bg-black text-white">
                    {c}
                </option>
            ))}
        </select>
    </div>
);

export const ContactNumberField = ({ form, set }) => (
    <div>
        <label className={labelClass}>Contact Number *</label>
        <div className="flex gap-2.5">
            <select
                data-testid="country-code-select"
                value={form.country_code}
                onChange={(e) => set("country_code", e.target.value)}
                className={`${inputClass} w-32 appearance-none cursor-pointer`}
            >
                {COUNTRY_CODES.map((c) => (
                    <option
                        key={c.label}
                        value={c.code}
                        className="bg-black text-white"
                    >
                        {c.label}
                    </option>
                ))}
            </select>
            <input
                data-testid="contact-number-input"
                type="tel"
                inputMode="numeric"
                value={form.contact_number}
                onChange={(e) =>
                    set("contact_number", onlyDigits(e.target.value))
                }
                onKeyPress={(e) => {
                    if (!/[0-9 ]/.test(e.key)) e.preventDefault();
                }}
                placeholder="12 345 6789"
                className={inputClass}
            />
        </div>
    </div>
);
